export const RESET_STATE = 'TRM_RESET_STATE';
export const CURRENT_ITEM = 'TRM_CURRENT_ITEM';

export const REQUEST_LOADING = 'TRM_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'TRM_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'TRM_REQUEST_FAILED';

export const CURRENT_ACTION = 'TRM_CURRENT_ACTION';
export const RESET_ACTION = 'TRM_RESET_ACTION';
